/* Leasing-Anfrage Formularseite (seit 2026-09-30, formVersion "cart-v6")
   Liest den Warenkorb (vom Server gerendert) und den im Warenkorb gewählten Partner (localStorage „rachow-leasing“). */
(function () {
  'use strict';
  var STATE_KEY = 'rachow-leasing';
  var DRAFT_KEY = 'rachow-leasing-formular';
  var root = document.querySelector('[data-lc-root]');
  var cfgEl = document.querySelector('[data-lc-config]');
  if (!root || !cfgEl) return;

  var CFG = JSON.parse(cfgEl.textContent);
  var partners = [];
  try { partners = JSON.parse(document.getElementById('rachow-leasing-partners').textContent); } catch (e) {}
  var byKey = {}; partners.forEach(function (p) { byKey[p.key] = p; });

  var eur = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var money = function (c) { return eur.format((Number(c) || 0) / 100); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  var st = {}; try { st = JSON.parse(localStorage.getItem(STATE_KEY) || '{}') || {}; } catch (e) {}
  var P = byKey[st.partner];
  var items = (CFG.cart && CFG.cart.items) || [];
  var total = items.reduce(function (s, i) { return s + i.linePrice; }, 0);

  var F = {
    leasingCode: '', otherProviderName: '', servicePackage: '', customServicePackage: '',
    companyName: '', companyStreet: '', companyHouseNumber: '', companyZip: '', companyCity: '', customerMessage: '',
    salutation: '', firstName: '', lastName: '', street: '', houseNumber: '', zip: '', city: '', phone: '', email: '',
    bDay: '', bMonth: '', bYear: '', deliveryMethod: 'home', store: ''
  };
  try { var d = JSON.parse(localStorage.getItem(DRAFT_KEY) || 'null'); if (d) Object.keys(F).forEach(function (k) { if (d[k] != null) F[k] = d[k]; }); } catch (e) {}
  if (P && P.pickupOnly) F.deliveryMethod = 'pickup';
  var saveDraft = function () { try { localStorage.setItem(DRAFT_KEY, JSON.stringify(F)); } catch (e) {} };

  var view = 'form', errors = {}, sending = false, sendError = '', hpVal = '';

  /* ---------- Vorbedingungen (gleiche Regeln wie im Warenkorb) ---------- */
  function blockReason() {
    if (!items.length) return 'Dein Warenkorb ist leer.';
    if (st.mode !== 'lease' || !P) return 'Bitte wähle im Warenkorb „Leasen“ und deinen Leasing-Partner.';
    if (!items.some(function (i) { return i.bike; })) return 'Leasing ist nur zusammen mit einem Fahrrad oder E-Bike möglich.';
    if (items.some(function (i) { return i.excluded; })) return 'Im Warenkorb liegt ein Artikel, der nicht geleast werden kann.';
    if (P.minSum && total < P.minSum * 100) return 'Die Mindestleasingsumme von ' + money(P.minSum * 100) + ' bei ' + P.label + ' ist noch nicht erreicht.';
    if (!lockInCart() && (P.lockMode === 'required' || !st.ownsLock)) return 'Bitte füge ein passendes Schloss hinzu oder bestätige im Warenkorb, dass du bereits eins besitzt.';
    return '';
  }
  function hasPkg() { return !!(P && P.servicePackages && P.servicePackages.length); }
  function lockInCart() { return items.filter(function (i) { return i.lock && P && i.unitPrice >= P.lockMin * 100; })[0]; }

  /* ---------- Bausteine ---------- */
  function logo(p) {
    return p.logo ? '<img class="lc-logo" src="' + esc(p.logo) + '" alt="' + esc(p.label) + '">' : '<span class="lc-logo lc-logo--word">' + esc(p.label) + '</span>';
  }
  function err(k) { return errors[k] ? '<p class="lc-err" id="e-' + k + '">' + esc(errors[k]) + '</p>' : ''; }
  function attrs(k, req) { return ' id="f-' + k + '" name="' + k + '" data-k="' + k + '"' + (req ? ' required aria-required="true"' : '') + (errors[k] ? ' aria-invalid="true" aria-describedby="e-' + k + '"' : ''); }
  function input(k, label, opt) {
    opt = opt || {};
    return '<div class="lc-field' + (opt.cls ? ' ' + opt.cls : '') + '">' + (label ? '<label for="f-' + k + '">' + label + (opt.req ? ' <span aria-hidden="true">*</span>' : '') + '</label>' : '') +
      '<input type="' + (opt.type || 'text') + '"' + attrs(k, opt.req) + ' value="' + esc(F[k]) + '"' + (opt.ac ? ' autocomplete="' + opt.ac + '"' : '') + (opt.ph ? ' placeholder="' + esc(opt.ph) + '"' : '') + (opt.mode ? ' inputmode="' + opt.mode + '"' : '') + (opt.max ? ' maxlength="' + opt.max + '"' : '') + (opt.aria ? ' aria-label="' + esc(opt.aria) + '"' : '') + '>' + err(k) + '</div>';
  }
  function select(k, label, options, opt) {
    opt = opt || {};
    return '<div class="lc-field' + (opt.cls ? ' ' + opt.cls : '') + '">' + (label ? '<label for="f-' + k + '">' + label + (opt.req ? ' <span aria-hidden="true">*</span>' : '') + '</label>' : '') +
      '<div class="lc-select"><select' + attrs(k, opt.req) + (opt.aria ? ' aria-label="' + esc(opt.aria) + '"' : '') + '><option value="">' + esc(opt.ph || 'Bitte wählen') + '</option>' +
      options.map(function (o) { var v = typeof o === 'object' ? o.value : o, t = typeof o === 'object' ? o.label : o; return '<option value="' + esc(v) + '"' + (String(F[k]) === String(v) ? ' selected' : '') + '>' + esc(t) + '</option>'; }).join('') +
      '</select></div>' + err(k) + '</div>';
  }

  function articles() {
    return '<section class="lc-articles" aria-labelledby="lc-art-h"><h2 id="lc-art-h" class="lc-h3">Artikelübersicht</h2><ul class="lc-list">' +
      items.map(function (i) {
        return '<li class="lc-art"><div class="lc-art__img">' + (i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="lc-art__txt"><p class="lc-art__title">' + esc(i.title) + '</p><p class="lc-art__meta">' + i.options.map(esc).join('<span aria-hidden="true"> · </span>') + (i.options.length ? '<br>' : '') + 'Menge: ' + i.quantity + '</p></div>' +
          '<p class="lc-art__price">' + money(i.linePrice) + '<sup>**</sup></p></li>';
      }).join('') +
      '</ul><div class="lc-sum"><span>Leasingpreis gesamt <small>(inkl. MwSt.)</small></span><strong>' + money(total) + '</strong></div>' +
      '<p class="lc-fine">** Leasingpreis in Euro inkl. MwSt., entspricht dem Kaufpreis. Die monatliche Rate erhältst du von deinem Leasinganbieter.</p></section>';
  }

  function lockLine() {
    var l = lockInCart();
    if (l) return '<p class="lc-ok">Schloss im Warenkorb: ' + esc(l.title) + '</p>';
    return '<p>Du hast bestätigt, dass du bereits ein Fahrradschloss im Wert von mind. ' + P.lockMin + ' € besitzt. Der Nachweis ist im Versicherungsfall erforderlich.</p>';
  }

  /* ---------- Formular ---------- */
  function formView() {
    var intro = P.intro || 'Deinem Leasingportal entnimmst du die Vorgaben deines Arbeitgebers zu den Rahmenvereinbarungen deines Leasings und Informationen zu leasingfähigem Zubehör.';
    var stores = CFG.stores.map(function (s) { return { value: s.value, label: s.name + ' – ' + s.info }; });

    var h = '<h1 class="lc-title">Leasingangebot anfordern</h1>';
    if (Object.keys(errors).length) h += '<div class="lc-alert" role="alert" tabindex="-1" data-alert>Bitte prüfe die markierten Felder.</div>';

    /* 1 */
    h += '<section class="lc-card" aria-labelledby="lc-h1"><h2 class="lc-h2" id="lc-h1"><span>1.</span> Bitte gib deine Leasingdaten an</h2>' +
      '<div class="lc-partner"><span class="lc-partner__label">Dein Leasingpartner:</span>' + logo(P) + '<a class="lc-link" href="' + CFG.cartUrl + '?mode=leasing">Ändern</a></div>' +
      '<div class="lc-text"><p>' + intro + '</p>' + lockLine() + '</div>';
    if (P.other) h += input('otherProviderName', 'Name deines Leasinganbieters', { req: true, max: 120 });
    h += '<div class="lc-field"><label for="f-leasingCode" class="lc-label-text">' + P.idLabel + ' <span aria-hidden="true">*</span></label>' +
      '<input type="text"' + attrs('leasingCode', true) + ' value="' + esc(F.leasingCode) + '" maxlength="180" autocomplete="off">' + err('leasingCode') + '</div>';
    if (hasPkg()) {
      if (P.servicePackages.indexOf(F.servicePackage) < 0) F.servicePackage = '';
      h += select('servicePackage', 'Service-Paket', P.servicePackages, { req: true });
      if (F.servicePackage === 'Eigene Auswahl') h += input('customServicePackage', 'Dein gewünschtes Service-Paket', { req: true, max: 180 });
    }
    h += '<p class="lc-sub">Trage hier bitte die Anschrift deines Arbeitgebers ein.</p>' +
      input('companyName', P.companyLabel || 'Firmenname / Arbeitgeber', { req: true, ac: 'organization', max: 180 }) +
      '<div class="lc-row lc-row--street">' + input('companyStreet', 'Straße', { req: true, max: 160 }) + input('companyHouseNumber', 'Hausnummer', { req: true, max: 30 }) + '</div>' +
      '<div class="lc-row lc-row--zip">' + input('companyZip', 'PLZ', { req: true, mode: 'numeric', max: 5 }) + input('companyCity', 'Stadt', { req: true, max: 120 }) + '</div>' +
      '<div class="lc-field"><label for="f-customerMessage">Deine Mitteilung an uns</label><textarea' + attrs('customerMessage') + ' rows="4" maxlength="3000">' + esc(F.customerMessage) + '</textarea></div>' +
      '</section>';

    /* 2 */
    h += '<section class="lc-card" aria-labelledby="lc-h2"><h2 class="lc-h2" id="lc-h2"><span>2.</span> Bitte gib deine Kontaktdaten an</h2>' +
      '<p class="lc-sub">Trage hier bitte deine private Anschrift ein.</p>' +
      select('salutation', 'Anrede', ['Herr', 'Frau', 'Divers'], { req: true }) +
      '<div class="lc-row">' + input('firstName', 'Vorname', { req: true, ac: 'given-name', max: 100 }) + input('lastName', 'Nachname', { req: true, ac: 'family-name', max: 100 }) + '</div>' +
      '<div class="lc-row lc-row--street">' + input('street', 'Straße', { req: true, ac: 'address-line1', max: 160 }) + input('houseNumber', 'Hausnummer', { req: true, max: 30 }) + '</div>' +
      '<div class="lc-row lc-row--zip">' + input('zip', 'PLZ', { req: true, ac: 'postal-code', mode: 'numeric', max: 5 }) + input('city', 'Stadt', { req: true, ac: 'address-level2', max: 120 }) + '</div>' +
      '<div class="lc-row">' + input('phone', 'Telefon', { req: true, type: 'tel', ac: 'tel', ph: 'Für Liefertermin und Rückfragen', max: 50 }) + input('email', 'E-Mail-Adresse', { req: true, type: 'email', ac: 'email', max: 180 }) + '</div>' +
      '<fieldset class="lc-field lc-birth"><legend>Geburtsdatum <span aria-hidden="true">*</span></legend><div class="lc-row lc-row--birth">' +
      input('bDay', '', { req: true, mode: 'numeric', ph: 'Tag', max: 2, ac: 'bday-day', aria: 'Geburtstag (Tag)' }) +
      select('bMonth', '', MONTHS.map(function (m, i) { return { value: String(i + 1), label: m }; }), { req: true, ph: 'Monat', aria: 'Geburtsmonat' }) +
      input('bYear', '', { req: true, mode: 'numeric', ph: 'Jahr', max: 4, ac: 'bday-year', aria: 'Geburtsjahr' }) +
      '</div>' + err('birth') + '</fieldset></section>';

    /* 3 */
    var radio = function (v, label, dis) {
      return '<label class="lc-radio' + (dis ? ' is-disabled' : '') + '"><input type="radio" name="deliveryMethod" data-k="deliveryMethod" value="' + v + '"' + (F.deliveryMethod === v ? ' checked' : '') + (dis ? ' disabled' : '') + '><span>' + label + '</span></label>';
    };
    h += '<section class="lc-card" aria-labelledby="lc-h3"><h2 class="lc-h2" id="lc-h3"><span>3.</span> Wähle deine Lieferoption</h2>' +
      '<div class="lc-text"><p>Bei <b>Filialabholung</b> übergeben wir dir dein Fahrrad vollständig montiert und weisen dich in die Nutzung ein. Wir melden uns, sobald dein Leasingrad abholbereit ist.<br>Schicken wir das Fahrrad an <b>deine Adresse</b>, musst du lediglich die Pedale montieren und den Lenker geradestellen.</p>' +
      (P.pickupOnly ? '<p class="lc-warn">Bei ' + esc(P.label) + ' ist nur Filialabholung möglich.</p>' : '') + '</div>' +
      '<div class="lc-radios" role="radiogroup" aria-label="Lieferoption">' + radio('home', 'Ich möchte, dass mein Fahrrad an meine private Anschrift versendet wird', P.pickupOnly) + radio('pickup', 'Filialabholung') + '</div>' +
      (F.deliveryMethod === 'pickup' ? select('store', 'Filiale', stores, { req: true, cls: 'lc-store' }) : '') + err('deliveryMethod') + '</section>';

    h += articles();
    h += '<p class="lc-consent">Mit Klick auf „Eingaben überprüfen und weiter“ willigst du in die Weitergabe deiner oben unter 1 und 2 eingegebenen Daten an den unter 1 ausgewählten Leasingpartner durch uns ein. Deine Einwilligung kannst du jederzeit kostenfrei mit Wirkung für die Zukunft per E-Mail an ' + esc(CFG.contactEmail) + ' widerrufen. Weitere Informationen findest du in den <a href="' + esc(CFG.privacyUrl) + '" target="_blank" rel="noopener">Datenschutzhinweisen</a>.</p>' +
      '<div class="lc-actions"><a class="lc-btn lc-btn--line" href="' + CFG.cartUrl + '?mode=leasing">Zurück zum Warenkorb</a><button type="button" class="lc-btn lc-btn--dark" data-act="review">Eingaben überprüfen und weiter</button></div>' +
      '<input type="text" name="website" data-k="website" class="lc-hp" tabindex="-1" autocomplete="off" aria-hidden="true">';
    return h;
  }

  /* ---------- Prüfen ---------- */
  function birthIso() {
    var d = Number(F.bDay), m = Number(F.bMonth), y = Number(F.bYear);
    if (!d || !m || !y) return '';
    var dt = new Date(Date.UTC(y, m - 1, d));
    if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== m - 1 || dt.getUTCDate() !== d) return '';
    return y + '-' + String(m).padStart(2, '0') + '-' + String(d).padStart(2, '0');
  }
  function validate() {
    var e = {};
    var req = function (k, label) { if (!String(F[k] || '').trim()) e[k] = 'Bitte gib ' + label + ' an.'; };
    if (P.other) req('otherProviderName', 'den Namen deines Leasinganbieters');
    req('leasingCode', 'deine ' + P.idName);
    if (hasPkg() && !F.servicePackage) e.servicePackage = 'Bitte wähle ein Service-Paket.';
    if (hasPkg() && F.servicePackage === 'Eigene Auswahl' && !String(F.customServicePackage).trim()) e.customServicePackage = 'Bitte beschreibe dein gewünschtes Service-Paket.';
    req('companyName', 'den Firmennamen'); req('companyStreet', 'die Straße'); req('companyHouseNumber', 'die Hausnummer'); req('companyCity', 'die Stadt');
    if (!/^\d{5}$/.test(String(F.companyZip).trim())) e.companyZip = 'Bitte gib eine fünfstellige PLZ an.';
    if (!F.salutation) e.salutation = 'Bitte wähle eine Anrede.';
    req('firstName', 'deinen Vornamen'); req('lastName', 'deinen Nachnamen'); req('street', 'die Straße'); req('houseNumber', 'die Hausnummer'); req('city', 'die Stadt');
    if (!/^\d{5}$/.test(String(F.zip).trim())) e.zip = 'Bitte gib eine fünfstellige PLZ an.';
    if (String(F.phone).replace(/\D/g, '').length < 6) e.phone = 'Bitte gib eine gültige Telefonnummer an.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(F.email).trim())) e.email = 'Bitte gib eine gültige E-Mail-Adresse an.';
    var b = birthIso(), yr = Number(F.bYear), now = new Date().getFullYear();
    if (!b || yr < 1900 || yr > now - 16) e.birth = 'Bitte gib ein gültiges Geburtsdatum an.';
    if (F.deliveryMethod === 'pickup' && !F.store) e.store = 'Bitte wähle eine Filiale.';
    if (P.pickupOnly && F.deliveryMethod !== 'pickup') e.deliveryMethod = 'Bei ' + P.label + ' ist nur Filialabholung möglich.';
    return e;
  }

  function block(title, lines, anchor) {
    return '<div class="lc-rv"><h2 class="lc-h2">' + title + '</h2>' + lines.filter(Boolean).map(function (l) { return '<p>' + l + '</p>'; }).join('') +
      '<button type="button" class="lc-link" data-act="edit" data-anchor="' + anchor + '">Ändern</button></div>';
  }
  function reviewView() {
    var e = esc;
    var addrC = e(F.companyName) + '<br>' + e(F.companyStreet) + ' ' + e(F.companyHouseNumber) + '<br>' + e(F.companyZip) + ' ' + e(F.companyCity);
    var bd = birthIso().split('-').reverse().join('.');
    var store = CFG.stores.filter(function (s) { return s.value === F.store; })[0];
    var h = '<h1 class="lc-title">Leasingangebot anfordern</h1><p class="lc-lead">Bitte prüfe deine Angaben. Erst mit „Anfrage senden“ geht die Anfrage an uns.</p>' + articles() +
      '<div class="lc-card lc-card--review">' +
      block('1. Deine Leasingdaten', [
        '<span class="lc-partner__label">Leasingpartner:</span> ' + logo(P) + (P.other ? ' ' + e(F.otherProviderName) : ''),
        '<b>' + e(P.idName) + '</b><br>' + e(F.leasingCode),
        hasPkg() ? '<b>Service-Paket</b><br>' + e(F.servicePackage === 'Eigene Auswahl' ? 'Eigene Auswahl: ' + F.customServicePackage : F.servicePackage) : '',
        '<b>Anschrift deines Arbeitgebers</b><br>' + addrC,
        F.customerMessage ? '<b>Deine Mitteilung</b><br>' + e(F.customerMessage).replace(/\n/g, '<br>') : '',
        '<b>Schloss</b><br>' + (lockInCart() ? e(lockInCart().title) + ' (im Warenkorb)' : 'Eigenes Schloss vorhanden (mind. ' + P.lockMin + ' €)')
      ], 'lc-h1') +
      block('2. Deine Kontaktdaten', [
        '<b>' + e(F.email) + '</b>',
        e(F.salutation) + ' ' + e(F.firstName) + ' ' + e(F.lastName) + '<br>' + e(F.street) + ' ' + e(F.houseNumber) + '<br>' + e(F.zip) + ' ' + e(F.city) + '<br>' + e(F.phone) + '<br>Geburtsdatum: ' + bd
      ], 'lc-h2') +
      block('3. Lieferoption', [
        F.deliveryMethod === 'pickup'
          ? '<b>Filialabholung:</b><br>' + e(store ? store.value + ', ' + store.info : F.store)
          : '<b>Lieferung an meine private Adresse:</b><br>' + e(F.street) + ' ' + e(F.houseNumber) + '<br>' + e(F.zip) + ' ' + e(F.city)
      ], 'lc-h3') +
      '</div>' +
      (sendError ? '<div class="lc-alert" role="alert">' + esc(sendError) + '</div>' : '') +
      '<div class="lc-actions"><button type="button" class="lc-btn lc-btn--line" data-act="edit" data-anchor="lc-h1">Zurück</button>' +
      '<button type="button" class="lc-btn lc-btn--dark" data-act="send"' + (sending ? ' disabled aria-busy="true"' : '') + '>' + (sending ? 'Wird gesendet …' : 'Anfrage senden') + '</button></div>';
    return h;
  }

  function doneView(ref) {
    return '<div class="lc-done"><div class="lc-done__ico" aria-hidden="true"><svg width="30" height="30" viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
      '<h1 class="lc-title">Vielen Dank, deine Anfrage ist bei uns.</h1>' +
      '<p>Wir legen dein Angebot bei ' + esc(P.label) + ' an und melden uns per E-Mail an <b>' + esc(F.email) + '</b>.' + (ref ? ' Deine Referenz: <b>' + esc(ref) + '</b>.' : '') + '</p>' +
      '<p>Fragen? Ruf uns an: ' + esc(CFG.phone) + '</p><a class="lc-btn lc-btn--dark" href="/">Weiter stöbern</a></div>';
  }

  /* ---------- Rendern & Ereignisse ---------- */
  function render(focus) {
    var reason = blockReason();
    if (view !== 'done' && reason) {
      root.innerHTML = '<div class="lc-empty"><h1 class="lc-title">Leasingangebot anfordern</h1><p>' + esc(reason) + '</p><a class="lc-btn lc-btn--dark" href="' + CFG.cartUrl + '?mode=leasing">Zum Warenkorb</a></div>';
      return;
    }
    root.innerHTML = view === 'review' ? reviewView() : view === 'done' ? doneView(focus) : formView();
    if (view === 'form' && Object.keys(errors).length) {
      var first = root.querySelector('[aria-invalid="true"]') || root.querySelector('[data-alert]');
      if (first) first.focus();
    }
  }

  root.addEventListener('input', function (e) {
    var k = e.target.dataset && e.target.dataset.k; if (!k) return;
    if (k === 'website') { hpVal = e.target.value; return; }
    F[k] = e.target.value; saveDraft();
    if (errors[k]) { delete errors[k]; e.target.removeAttribute('aria-invalid'); var m = document.getElementById('e-' + k); if (m) m.remove(); }
  });
  root.addEventListener('change', function (e) {
    var k = e.target.dataset && e.target.dataset.k; if (!k) return;
    F[k] = e.target.value; saveDraft();
    if (k === 'servicePackage') { render(); var sp = document.getElementById('f-servicePackage'); if (sp) sp.focus(); return; }
    if (k === 'deliveryMethod') { if (F.deliveryMethod !== 'pickup') F.store = ''; render(); var r = root.querySelector('[name="deliveryMethod"]:checked'); if (r) r.focus(); }
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]'); if (!b) return;
    var act = b.dataset.act;
    if (act === 'review') {
      errors = validate();
      if (Object.keys(errors).filter(function (k) { return errors[k]; }).length) { errors = pick(errors); render(); return; }
      view = 'review'; sendError = ''; render(); window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (act === 'edit') {
      view = 'form'; errors = {}; render();
      var t = document.getElementById(b.dataset.anchor); if (t) t.scrollIntoView({ block: 'start' });
    } else if (act === 'send') {
      send();
    }
  });
  function pick(o) { var r = {}; Object.keys(o).forEach(function (k) { if (o[k]) r[k] = o[k]; }); return r; }

  function send() {
    if (sending) return;
    sending = true; sendError = ''; render();
    var payload = {
      formVersion: 'cart-v6',
      provider: P.key,
      otherProviderName: F.otherProviderName,
      leasingCode: F.leasingCode.trim(),
      servicePackage: hasPkg() ? F.servicePackage : '',
      customServicePackage: hasPkg() && F.servicePackage === 'Eigene Auswahl' ? F.customServicePackage.trim() : '',
      companyName: F.companyName.trim(), companyStreet: F.companyStreet.trim(), companyHouseNumber: F.companyHouseNumber.trim(),
      companyZip: String(F.companyZip).trim(), companyCity: F.companyCity.trim(),
      salutation: F.salutation, firstName: F.firstName.trim(), lastName: F.lastName.trim(),
      street: F.street.trim(), houseNumber: F.houseNumber.trim(), zip: String(F.zip).trim(), city: F.city.trim(),
      phone: F.phone.trim(), email: F.email.trim(), birthDate: birthIso(),
      deliveryMethod: F.deliveryMethod, store: F.deliveryMethod === 'pickup' ? F.store : '',
      customerMessage: F.customerMessage,
      ownsLock: !lockInCart() && !!st.ownsLock,
      discountCodes: [],
      cartToken: CFG.cart.token || '',
      items: items.map(function (i) { return { variantId: i.variantId, quantity: i.quantity, properties: i.properties || {} }; }),
      website: hpVal,
      turnstileToken: ''
    };
    fetch(String(CFG.workerUrl).replace(/\/$/, '') + '/create-draft-order', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    }).then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { return { ok: res.ok && j.ok, j: j }; }); })
      .then(function (r) {
        sending = false;
        if (!r.ok) { sendError = (r.j && r.j.message) || 'Die Anfrage konnte nicht gesendet werden. Bitte versuche es erneut.'; render(); return; }
        try { localStorage.removeItem(DRAFT_KEY); st.ownsLock = false; st.mode = 'buy'; localStorage.setItem(STATE_KEY, JSON.stringify(st)); } catch (e) {}
        fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).catch(function () {});
        view = 'done'; render(r.j.reference || ''); window.scrollTo({ top: 0 });
      })
      .catch(function () { sending = false; sendError = 'Keine Verbindung. Bitte prüfe deine Internetverbindung und versuche es erneut, oder ruf uns an: ' + CFG.phone + '.'; render(); });
  }

  render();
})();
